<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center"></div>
      <div class="d-sm-flex align-items-center"></div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="row mb-20">
        <div class="col-md-6 d-flex align-items-center">
          <label>Voir</label>
          <v-select
            v-model="filters.per_page"
            :options="[10, 25, 50]"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @input="getRecords()"
          />
          <label>sur {{ filters.total }} entités</label>
        </div>
        <div class="col-md-6 d-flex align-items-center">
          <input
            type="text"
            class="form-control shadow-none text-black rounded-0"
            placeholder="Chercher"
            @change="filter()"
            @input="handleInput"
            v-model="filters.searchTerm"
          />
        </div>
      </div>

      <vue-good-table :columns="columns" :rows="rows" :loading="isLoader">
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>

        <template #table-row="props">
          <div v-if="props.column.field == 'logo'">
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                <img
                  :src="props.row.logo"
                  class="rounded-circle me-8"
                  width="24"
                  height="24"
                  alt="user"
                />
                {{ props.row.name }}
              </div>
            </div>
          </div>

          <span v-else-if="props.column.field === 'info'">
            <!-- <span><b># : </b>{{ props.row.ref }}</span
            ><br /> -->
            <span><b>CIN : </b>{{ props.row.cin }}</span
            ><br />

            <span><b>Téléphone : </b>{{ props.row.phone }}</span
            ><br />
            <span><b>Email : </b>{{ props.row.email }}</span
            ><br />
            <span><b>Ville : </b>{{ props.row.city }}</span
            ><br />
            <span><b>Adresse : </b>{{ props.row.address }}</span>
            <span v-if="props.row.store_name"> {{ props.row.store_name }}</span>
          </span>
          <div
            v-else-if="props.column.field === 'statut'"
            v-html="verificationBadges(props.row)"
          ></div>

          <span
            v-else-if="props.column.field === 'created_at'"
            class="text-nowrap"
          >
            {{ getDate(props.row.created_at) }}
          </span>

          <template v-else-if="props.column.field === 'action'">
            <div class="d-flex align-items-center gap-2 action-buttons">
              <!-- 👁 Détails -->
              <button
                v-if="auth.can('CUSTOMERS')"
                class="btn btn-sm btn-outline-primary action-btn"
                title="Voir les détails"
                @click="openModal(props.row)"
              >
                <i class="flaticon-view"></i>
              </button>

              <!-- ✅ Valider CIN -->
              <button
                v-if="
                  auth.can('CUSTOMERS') &&
                  props.row.cin_verified == 0 &&
                  props.row.ask_cin_verified == 1
                "
                class="btn btn-sm btn-outline-success action-btn"
                title="Valider le CIN"
                @click="validateCIN(props.row)"
              >
                <i class="flaticon-check"></i>
              </button>

              <!-- 📄 Valider Contrat -->
              <button
                v-if="
                  auth.can('CUSTOMERS') &&
                  props.row.contrat_verified == 0 &&
                  props.row.ask_cntr_verified == 1
                "
                class="btn btn-sm btn-outline-success action-btn"
                title="Valider le contrat"
                @click="validateCTR(props.row)"
              >
                <i class="flaticon-check"></i>
              </button>
            </div>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="filters"
        :offset="9"
        @paginate="getRecords"
      />
    </div>
  </div>

  <!-- ================= MODAL ================= -->
  <div class="modal fade" id="modal_details" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-4">
        <div class="modal-header">
          <h5 class="modal-title">Vérification – {{ docs?.customer?.name }}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>

        <div class="modal-body">
          <!-- DOCUMENTS -->
          <div class="row g-4">
            <!-- CIN RECTO -->
            <div class="col-md-6" v-if="docs?.customer?.cin_recto">
              <p class="fw-bold mb-2">CIN Recto</p>
              <a
                v-if="isPdf(docs.customer.cin_recto)"
                :href="docs.customer.cin_recto"
                target="_blank"
                class="btn btn-outline-primary"
              >
                Ouvrir PDF
              </a>
              <img
                v-else
                :src="docs.customer.cin_recto"
                class="img-fluid rounded shadow"
              />
            </div>

            <!-- CIN VERSO -->
            <div class="col-md-6" v-if="docs?.customer?.cin_verso">
              <p class="fw-bold mb-2">CIN Verso</p>
              <a
                v-if="isPdf(docs.customer.cin_verso)"
                :href="docs.customer.cin_verso"
                target="_blank"
                class="btn btn-outline-primary"
              >
                Ouvrir PDF
              </a>
              <img
                v-else
                :src="docs.customer.cin_verso"
                class="img-fluid rounded shadow"
              />
            </div>

            <!-- CONTRAT -->
            <div class="col-12" v-if="docs?.customer?.contrat_file">
              <p class="fw-bold mb-2">Contrat</p>
              <a
                :href="docs.customer.contrat_file"
                target="_blank"
                class="btn btn-outline-primary"
              >
                Ouvrir le contrat
              </a>
            </div>

            <!-- EMPTY STATE -->
            <div
              class="col-12 text-center text-muted"
              v-if="
                !docs?.customer?.cin_recto &&
                !docs?.customer?.cin_verso &&
                !docs?.customer?.contrat_file
              "
            >
              Aucun document disponible
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { onMounted, reactive, ref } from "vue";
import flatpickr from "flatpickr";
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import { useAuthStore } from "@/stores/auth";
import Swal from "sweetalert2";
import { Modal } from "bootstrap";

export default {
  name: "ListeSpents",

  setup: () => {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const rows = ref([]);
    const isLoader = ref(false);
    const noteRow = ref(null);
    const columns = [
      {
        label: "Logo",
        field: "logo",
      },
      {
        label: "Client",
        field: "info",
      },
      {
        label: "Statut vérifications",
        field: "statut",
      },
      {
        label: "Date de création",
        field: "created_at",
      },
      {
        label: "Action",
        field: "action",
      },
    ];
    const filters = reactive({
      searchTerm: "",
      searchClient: "",
      searchSDate: "",
      searchEDate: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    onMounted(() => {
      getRecords();
    });
    async function getRecords(page = 1) {
      isLoader.value = true;
      filters.current_page = page;
      try {
        const response = await api.get(
          `/api/auth/verifications?client=${filters.searchClient}&searchDatestart=${filters.searchSDate}&searchDateend=${filters.searchEDate}&searchTerm=${filters.searchTerm}&page=${filters.current_page}&per_page=${filters.per_page}`
        );

        rows.value = response.data.users.data;
        Object.assign(filters, response.data.users);
      } catch (error) {
        console.error("Erreur lors du chargement des enregistrements:", error);
      } finally {
        isLoader.value = false;
      }
    }

    function getDate(value) {
      return moment(String(value)).format("YYYY-MM-DD HH:mm");
    }
    function resolveUserStatusVariant(status) {
      if (status == 0) return "warning";
      if (status == 1) return "info";
      return "danger";
    }

    function filter() {
      //   filters.searchCustomer = customer_filter.id
      //   filters.searchStatut = status_filter
      //   filters.searchStore = store_filter.id
      //   filters.searchSDate = ($refs.myInput.dateRange.start == undefined || $refs.myInput.dateRange.start == 'undefined') ? '' : convert($refs.myInput.dateRange.start)
      //   filters.searchEDate = ($refs.myInput.dateRange.end == undefined || $refs.myInput.dateRange.end == 'undefined') ? '' : convert($refs.myInput.dateRange.end)
      filters.current_page = 1;
      getRecords();
    }
    function convert(str) {
      const date = new Date(str);
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }
    function removeFilter() {
      //   filters.searchCustomer = filters.searchStatut = filters.searchStore = "";
      //   customer_filter = store_filter = { id: '', name: '' }
      //   date_filter = status_filter = type_date_filter = ''
      //   $refs.myInput.dateRange = {}
      filters.current_page = 1;
      getRecords();
    }
    function handleInput() {
      //   // Clear previous debounce timer
      //   clearTimeout(debounceTimer);

      //   // Set a new debounce timer
      //   debounceTimer = setTimeout(() => {
      //     if (!searchTerm || searchTerm === '') {
      //     filters.searchTerm = searchTerm
      //     filter()
      //   } else if (searchTerm && searchTerm.length > 4) {
      //     filters.searchTerm = searchTerm
      //     filter()
      //   }
      //   }, 500); // Adjust the delay (in milliseconds) as needed
      filter();
    }

    async function removeSpent(row) {
      const data = new FormData();

      const result = await Swal.fire({
        text: "Vous voulez supprimer cette dépense ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      });

      if (result.isConfirmed) {
        try {
          const res = await api.delete(`/api/auth/spents/${row.id}`);

          if (res.data.success) {
            showToast("Dépense est bien supprimée", "success");

            getRecords(); // 🔹 if you are using Composition API. If still in Options API, keep `getRecords()`.
          } else {
            showToast("Vous pouvez pas le supprimer!", "error");
          }
        } catch (error) {
          console.error("Erreur suppression BL:", error);
          showToast("Something went wrong! Veuillez réessayer", "error");
        }
      }
    }

    async function validateCIN(row) {
      const { value: formValues } = await Swal.fire({
        title: "Approbation de la vérification C.I.N",
        html: `
      <div class="text-start">
        <label class="form-label">Statut</label>
        <select id="swal-statut" class="form-select mb-3">
          <option value="">-- Choisir le statut --</option>
          <option value="1">Approuver</option>
          <option value="2">Désapprouver</option>
        </select>

        <label class="form-label">Raison</label>
        <textarea
          id="swal-raison"
          class="form-control"
          rows="3"
          placeholder="Raison (obligatoire si désapprouvé)"
        ></textarea>
      </div>
    `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Valider",
        cancelButtonText: "Annuler",
        preConfirm: () => {
          const statut = (
            document.getElementById("swal-statut") as HTMLSelectElement
          ).value;
          const raison = (
            document.getElementById("swal-raison") as HTMLTextAreaElement
          ).value;

          if (!statut) {
            Swal.showValidationMessage("Veuillez choisir un statut");
            return false;
          }

          if (statut === "0" && !raison.trim()) {
            Swal.showValidationMessage(
              "La raison est obligatoire en cas de désapprobation"
            );
            return false;
          }

          return { statut, raison };
        },
      });

      if (!formValues) return;

      try {
        const res = await api.post(
          `/api/auth/verifications/active-cin/${row.id}`,
          formValues
        );

        if (res.data.success) {
          showToast("Vérification CIN mise à jour avec succès", "success");
          getRecords();
        } else {
          showToast(res.data.message || "Action impossible", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Erreur serveur, veuillez réessayer", "error");
      }
    }

    async function validateCTR(row) {
      const { value: formValues } = await Swal.fire({
        title: "Approbation de la vérification du Contrat",
        html: `
      <div class="text-start">
        <label class="form-label">Statut</label>
        <select id="swal-statut" class="form-select mb-3">
          <option value="">-- Choisir le statut --</option>
          <option value="1">Approuver</option>
          <option value="2">Désapprouver</option>
        </select>

        <label class="form-label">Raison</label>
        <textarea
          id="swal-raison"
          class="form-control"
          rows="3"
          placeholder="Raison (obligatoire si désapprouvé)"
        ></textarea>
      </div>
    `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Valider",
        cancelButtonText: "Annuler",
        preConfirm: () => {
          const statut = (document.getElementById("swal-statut") as HTMLSelectElement).value;
          const raison = (document.getElementById("swal-raison") as HTMLTextAreaElement).value;

          if (!statut) {
            Swal.showValidationMessage("Veuillez choisir un statut");
            return false;
          }

          if (statut === "0" && !raison.trim()) {
            Swal.showValidationMessage(
              "La raison est obligatoire en cas de désapprobation"
            );
            return false;
          }

          return { statut, raison };
        },
      });

      if (!formValues) return;

      try {
        const res = await api.post(
          `/api/auth/verifications/active-contrat/${row.id}`,
          formValues
        );

        if (res.data.success) {
          showToast(
            "Vérification du contrat mise à jour avec succès",
            "success"
          );
          getRecords();
        } else {
          showToast(res.data.message || "Action impossible", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Erreur serveur, veuillez réessayer", "error");
      }
    }

    async function getPDF(row) {
      try {
        const response = await api.get(`/api/auth/BCRPDF/${row.id}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
      } catch (error) {
        console.error("Erreur génération PDF:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Impossible de générer le PDF",
        });
      }
    }

    function showRow(row) {
      console.log(row);
      //   noteRow.value = row;
      //   const modalElement = document.getElementById("noteModal");
      //   if (modalElement) {
      //     const modal = new bootstrap.Modal(modalElement);
      //     modal.show();
      //   }
    }

    const verificationBadges = (c: any): string => {
      let typeC = "";
      let typeN = "";

      // ===== CONTRAT =====
      if (c.ask_cntr_verified === 1) {
        if (c.contrat_verified === 0) {
          typeN = `<span class="badge text-outline-info">Nouvelle (Contrat)</span>`;
        } else if (c.contrat_verified === 1) {
          typeN = `<span class="badge text-outline-success">Approuvée (Contrat)</span>`;
        } else if (c.contrat_verified === 2) {
          typeN = `<span class="badge text-outline-danger">Désapprouvée (Contrat)</span>`;
        }
      }

      // ===== CIN =====
      if (c.ask_cin_verified === 1) {
        if (c.cin_verified === 0) {
          typeC = `<span class="badge text-outline-info mb-1 d-inline-block">Nouvelle (CIN)</span>`;
        } else if (c.cin_verified === 1) {
          typeC = `<span class="badge text-outline-success mb-1 d-inline-block">Approuvée (CIN)</span>`;
        } else if (c.cin_verified === 2) {
          typeC = `<span class="badge text-outline-danger mb-1 d-inline-block">Désapprouvée (CIN)</span>`;
        }
      }

      console.log(typeC, typeN);
      return [typeC, typeN].filter(Boolean).join("<br/>");
    };

    /* ================= MODAL ================= */

    const showModal = ref(false);
    const selectedCustomer = ref<any>(null);
    const validationTarget = ref<"cin" | "contract" | null>(null);

    const docs = ref<any>({
      customer: {},
    });
    const status = ref("1");
    const reason = ref("");

    const openModal = async (
      c: any,
      target: "cin" | "contract" | null = null
    ) => {
      selectedCustomer.value = c;
      validationTarget.value = target;
      status.value = "1";
      reason.value = "";

      const { data } = await api.get(`/api/auth/verifications/show/${c.id}`);
      docs.value = data;

      const modalEl = document.getElementById("modal_details");
      if (modalEl) {
        const modal = new Modal(modalEl);
        modal.show();
      }
    };
    const closeModal = () => {
      showModal.value = false;
      selectedCustomer.value = null;
    };

    const isPdf = (url: string) => url.toLowerCase().endsWith(".pdf");
    return {
      auth,
      rows,
      isLoader,
      columns,
      filters,
      getRecords,
      getDate,
      resolveUserStatusVariant,
      filter,
      convert,
      removeFilter,
      handleInput,
      removeSpent,
      getPDF,
      noteRow,
      validateCTR,
      validateCIN,
      showRow,
      verificationBadges,
      // Modal
      showModal,
      selectedCustomer,
      docs,
      status,
      reason,
      openModal,
      closeModal,
      validationTarget,
      isPdf,
    };
  },
};
</script>


<style scoped>
.action-buttons {
  white-space: nowrap;
}

.action-btn {
  width: 34px;
  height: 34px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.action-btn i {
  font-size: 15px;
}

.action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
}
</style>